import React from 'react';
import { Link } from 'react-router-dom';
import { ArrowUpRight } from 'lucide-react';
import Img from './Img';

const ProductCard = ({ product, index = 0 }) => {
  return (
    <Link
      to={`/product/${product.slug}`}
      data-testid={`product-card-${product.id}`}
      className="card-dark group flex flex-col reveal-up"
      style={{ animationDelay: `${index * 50}ms` }}
    >
      <div className="relative aspect-[4/5] overflow-hidden bg-[#0A0A0A]">
        <Img
          src={product.image}
          alt={`${product.name} — ${product.category.replace('-', ' ')} (${product.suppliers.length} verified suppliers)`}
          variant="card"
          className="h-full w-full object-cover transition-transform duration-700 group-hover:scale-105"
        />
      </div>
      <div className="flex flex-1 flex-col p-5 text-platinum">
        {/* D-080 — category chip relocated beneath the image */}
        <div className="pb-3">
          <span className="label-overline inline-block rounded-full border px-3 py-1 text-gold" style={{ borderColor: 'rgba(200,169,107,0.55)' }}>{product.category.replace('-', ' ')}</span>
        </div>
        <h3 className="font-display text-lg leading-tight tracking-tight md:text-xl text-platinum" style={{ fontWeight: 600 }}>
          {product.name}
        </h3>
        <div className="mt-3 grid grid-cols-3 gap-1 border-t border-hairline pt-3 font-mono-data text-[11px] text-platinum-2">
          <div>
            <div className="text-muted-warm">MOQ</div>
            <div className="text-platinum">{product.moq}</div>
          </div>
          <div>
            <div className="text-muted-warm">LEAD</div>
            <div className="text-platinum">{product.leadTime.split(' ')[0]}d</div>
          </div>
          <div>
            <div className="text-muted-warm">PRICE</div>
            <div className="text-platinum">{product.pricing.split('–')[0]}</div>
          </div>
        </div>
        <div className="mt-auto flex items-center justify-between pt-4">
          <span className="font-mono-data text-[11px] text-platinum-2">{product.suppliers.length} suppliers</span>
          <span className="inline-flex items-center gap-1 label-overline text-gold">
            Explore <ArrowUpRight size={12} strokeWidth={1.5} />
          </span>
        </div>
      </div>
    </Link>
  );
};

export default ProductCard;
